import { render, staticRenderFns } from "./BottomLeft.vue?vue&type=template&id=1b51cec8&scoped=true"
import script from "./BottomLeft.vue?vue&type=script&lang=js"
export * from "./BottomLeft.vue?vue&type=script&lang=js"
import style0 from "./BottomLeft.vue?vue&type=style&index=0&id=1b51cec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b51cec8",
  null
  
)

export default component.exports